import React from 'react';

const Footer: React.FC = () => {
  return (
    <div
      style={{
        padding: '12px 0',
        textAlign: 'center',
        color: 'rgba(0, 0, 0, 0.25)',
        fontSize: 12,
      }}
    >
      PAM &copy; {new Date().getFullYear()} Powered by Go-admin
    </div>
  );
};

export default Footer;
